angular.module('app').component('objectRouteToolbar', {
    templateUrl: 'js/components/object-route-toolbar/index.html',
    controller: ORToolbarController,
    controllerAs: '$ort',
    bindings: {
        route: '&',
        closeRoute: '&',
        changeEventMode: '&',
        isMaxSpeedEventMode: '&',
    },
});

ORToolbarController.$inject = [];

function ORToolbarController() {
}
